/*
  ATD - Features 1
  - Mantiene sincronizados los dots con la posición del scroll del carrusel mobile.
  - Click en un dot hace scroll al item correspondiente.
  - Loop infinito mobile: al pasar el último item, vuelve al primero sin saltar visualmente.
    Técnica: se clonan los items una vez al final del grid; cuando el scroll alcanza
    el inicio del set clonado, se hace un reset silencioso (sin animación) al inicio
    del set original. Visualmente es indetectable porque los items son idénticos.
*/
(function () {
  const sections = document.querySelectorAll('.atd-features1');
  if (!sections.length) return;

  sections.forEach((section) => {
    const grid = section.querySelector('.atd-features1__grid');
    const dots = section.querySelectorAll('.atd-features1__dot');
    if (!grid || !dots.length) return;

    const originalCount = dots.length;
    let isInfinite = false;

    const isCarousel = () => grid.scrollWidth > grid.clientWidth + 1;
    const getItems = () => grid.querySelectorAll('.atd-features1__item');

    const setActive = (rawIndex) => {
      const realIndex = ((rawIndex % originalCount) + originalCount) % originalCount;
      dots.forEach((dot, i) => {
        dot.classList.toggle('atd-features1__dot--active', i === realIndex);
        dot.setAttribute('aria-current', i === realIndex ? 'true' : 'false');
      });
    };

    const setupInfinite = () => {
      if (isInfinite) return;
      if (originalCount < 2) return;
      const wrappers = Array.from(grid.children);
      wrappers.forEach((w) => {
        const clone = w.cloneNode(true);
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        clone.dataset.clone = '1';
        clone.setAttribute('aria-hidden', 'true');
        grid.appendChild(clone);
      });
      isInfinite = true;
    };

    const teardownInfinite = () => {
      if (!isInfinite) return;
      grid.querySelectorAll('[data-clone]').forEach((el) => el.remove());
      isInfinite = false;
    };

    let wrapTimeout = null;
    const scheduleWrapCheck = () => {
      if (!isInfinite) return;
      clearTimeout(wrapTimeout);
      wrapTimeout = setTimeout(() => {
        const items = getItems();
        if (!items.length) return;
        const itemWidth = items[0].getBoundingClientRect().width;
        if (itemWidth <= 0) return;
        const idx = Math.round(grid.scrollLeft / itemWidth);
        if (idx >= originalCount) {
          const prev = grid.style.scrollBehavior;
          grid.style.scrollBehavior = 'auto';
          grid.scrollLeft = grid.scrollLeft - originalCount * itemWidth;
          // Forzar reflow para que el cambio aplique antes de restaurar
          void grid.offsetHeight;
          grid.style.scrollBehavior = prev;
        }
      }, 200);
    };

    const handleScroll = () => {
      if (!isCarousel()) return;
      const items = getItems();
      if (!items.length) return;
      const itemWidth = items[0].getBoundingClientRect().width;
      if (itemWidth <= 0) return;
      const idx = Math.round(grid.scrollLeft / itemWidth);
      setActive(idx);
      scheduleWrapCheck();
    };

    let raf = null;
    grid.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        handleScroll();
      });
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const items = getItems();
        if (!items.length) return;
        const itemWidth = items[0].getBoundingClientRect().width;
        grid.scrollTo({ left: itemWidth * i, behavior: 'smooth' });
      });
    });

    const resync = () => {
      if (isCarousel()) {
        setupInfinite();
      } else {
        teardownInfinite();
      }
    };

    resync();
    window.addEventListener('resize', () => {
      // Pequeño debounce para evitar resync excesivo
      clearTimeout(resync._t);
      resync._t = setTimeout(resync, 200);
    });

    setActive(0);
  });
})();
